import React from 'react';
import { Helmet } from 'react-helmet';

export function DefaultSEO() {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>EduConnect - Expert Online Tutoring & Personalized Learning</title>
      <meta name="title" content="EduConnect - Expert Online Tutoring & Personalized Learning" />
      <meta name="description" content="Connect with expert tutors for personalized 1-to-1 online tutoring sessions. Interactive virtual learning tailored to your needs. Book your private tutor today!" />
      
      <meta name="google-site-verification" content="G-E77TBS2VWK" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.origin} />
      <meta property="og:title" content="EduConnect - Expert Online Tutoring & Personalized Learning" />
      <meta property="og:description" content="Connect with expert tutors for personalized 1-to-1 online tutoring sessions. Interactive virtual learning tailored to your needs. Book your private tutor today!" />
      <meta property="og:image" content="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?q=80&w=1200&h=630&fit=crop" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={window.location.origin} />
      <meta property="twitter:title" content="EduConnect - Expert Online Tutoring & Personalized Learning" />
      <meta property="twitter:description" content="Connect with expert tutors for personalized 1-to-1 online tutoring sessions. Interactive virtual learning tailored to your needs. Book your private tutor today!" />
      <meta property="twitter:image" content="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?q=80&w=1200&h=630&fit=crop" />

      {/* Additional Meta Tags */}
      <meta name="keywords" content="tutoring, 1-to-1, online, educational platform, personalized online tutoring, live online tutoring sessions, one-on-one virtual lessons, private online tutor, personalized virtual learning, interactive online tutoring" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="EduConnect" />

      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href="/vite.svg" />
      
      {/* Preconnect to External Resources */}
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://images.unsplash.com" crossOrigin="anonymous" />

      {/* DNS Prefetch */}
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
      <link rel="dns-prefetch" href="https://images.unsplash.com" />

      {/* Mobile Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-E77TBS2VWK"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-E77TBS2VWK');
        `}
      </script>
    </Helmet>
  );
}